import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import { singularOrPlural } from 'utils/common';
import Tree15 from '../svg/TreeProgression/Tree15.svg';
import TreeClouds from '../svg/TreeProgression/TreeClouds.svg';
import styles from './TreeProgression.module.css';

interface Props {
  treeCount: number | undefined;
  onlySpecifiedTree?: boolean;
}
export const TreeProgression = (props: Props) => {
  return (
    <AboutUsSiteInnerContainer overflowHidden borderRadius positionRelative>
      <div className={styles.container}>
        <div className={styles.textContainer}>
          <div className={styles.topText}>
            <h3 className="aboutUsTypographyHeaderMedium">Your forest</h3>
            <p className={styles.introText}>
              Every purchase plants a tree with <strong>veritree</strong>,
              supporting ecosystems, communities & more
            </p>
          </div>
          <div className={styles.bottomText}>
            <div className={''}>
              {props.treeCount != undefined && (
                <p>
                  You've planted{' '}
                  <strong
                    className={
                      styles.treeCount + ' aboutUsTypographyHeaderLarge'
                    }
                  >
                    {props.treeCount}
                    {singularOrPlural(props.treeCount, ' tree', ' trees')}
                  </strong>
                </p>
              )}
            </div>
            <div className={styles.bottomRight}>
              <Link href="https://impact.veritree.com/daymade">

                <strong>See impact</strong>

              </Link>
            </div>
          </div>
        </div>

        <div className={styles.treesContainer}>
          <Tree15
            className={
              styles.trees +
              ' ' +
              Array.from({ length: Math.min(props.treeCount || 0, 15) })
                .map((_, count) =>
                  !props.onlySpecifiedTree || props.treeCount === count + 1
                    ? styles['plantedTrees' + (count + 1)]
                    : '',
                )
                .join(' ')
            }
          />
        </div>
        <TreeClouds className={styles.clouds} />
      </div>
    </AboutUsSiteInnerContainer>
  );
};

export const CurrentUserTreeProgression = observer(() => {
  const userStore = useUserStore();

  return <TreeProgression treeCount={userStore.currentUser?.treesPlanted} />;
});
